import React from 'react';
import { useHistory } from 'react-router-dom';

type Props = {
  userId?: string;
  orgId?: string;
};

export const MyEngagementsTitle: React.FC<Props> = ({
  userId,
  orgId,
}): JSX.Element => {
  const history = useHistory();

  const onMyEngagementsClick = () => {
    if (userId && orgId) {
      history.push(`/orgs/${orgId}/users/${userId}/engagements`);
    }
  };

  const attrs = {
    wrapper: {
      className: 'detailed-view-page-title',
    },

    title: {
      className: 'detailed-view-page-title-link',
      onClick: onMyEngagementsClick,
    },
  };

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.title}>{'<'} My Engagements</div>
    </div>
  );
};
